import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

export const PrintMenuControl = ({ menuItem, children }) => menuItem ?
  <DropdownMenuItem asChild disabled={children.props.disabled} onSelect={e => e.preventDefault()}>{children}</DropdownMenuItem> : children;